import React from 'react'
import styled from 'styled-components'
import { colors } from '@entur/tokens'
import { Contrast } from '@entur/layout'

type ModalContainerProps = {
  open?: boolean
}

const ModalContainer = styled.div<ModalContainerProps>(
  (props) => `
  ${!props.open ? 'display: none;' : ''}
  position: absolute;
  background-color: ${colors.brand.blue};
  width: 25rem;
  z-index: 100;
  padding: 1rem;
  `
)

const ModalOverlay = styled.div<ModalContainerProps>(
  (props) => `
  ${!props.open ? 'display: none;' : ''}
  position: fixed;
  background-color: transparent;
  top:0;
  right:0;
  bottom:0;
  left:0;
  z-index: 90;
  `
)

type BlueModalProps = {
  open?: boolean
  setOpen?: (setOpen: boolean) => void
  children: React.ReactNode
}
export const BlueModal: React.FC<BlueModalProps> = (props) => {
  return (
    <>
      <ModalOverlay open={props.open} onClick={() => (props.setOpen ? props.setOpen(false) : {})} />
      <ModalContainer open={props.open}>
        <Contrast>{props.children}</Contrast>
      </ModalContainer>
    </>
  )
}
